// src/components/PersonalInterestModal.jsx
import React from 'react';

export default function PersonalInterestModal({ personalInterest, closeModal }) {
  const displayText =
    personalInterest && personalInterest.trim() !== ''
      ? personalInterest
      : "You do not have a profile yet, please swipe through more than 10 articles in the NewsMatcher UI to generate one for you.";

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Modal backdrop */}
      <div className="absolute inset-0 bg-gray-900 opacity-50" onClick={closeModal}></div>
      {/* Modal content */}
      <div className="bg-white rounded-lg p-6 relative max-w-lg w-full z-10">
        <h2 className="text-xl font-bold mb-4">Personal Interest</h2>
        <div className="overflow-y-auto max-h-64 text-gray-800 whitespace-pre-wrap">
          {displayText}
        </div>
        <button
          onClick={closeModal}
          className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Close
        </button>
      </div>
    </div>
  );
}
